/* @generated */
import { cookScrollbarRecipe } from "./scrollbar.css.esm.js";
function makeScrollbarClassName({
  borderRadius
}) {
  return cookScrollbarRecipe({
    borderRadius
  });
}
export {
  makeScrollbarClassName
};
